import { StyleSheet } from 'aphrodite';

import { THEME } from '../../../../../../../web/components-v2/Theme/theme';

const { spacing, common, typography, colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		justifyContent: 'center',
		// Stretch so a stage carrying failure detail doesn't push its own footer below its siblings'
		alignItems: 'stretch',
		width: '100%',
		gap: spacing.xxl,
	},
	stageWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		position: 'relative',
		gap: spacing.md,
	},
	preProcessCard: {
		position: 'relative',
		marginTop: spacing.xxl,
		width: 200,
		backgroundColor: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		padding: spacing.sm,
		transition: 'all 0.3s ease',
		boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
		fontSize: typography.fontSizes.sm,
	},
	preProcessConnector: {
		position: 'absolute',
		top: '50%',
		right: -spacing.md,
		width: spacing.md,
		height: 2,
		backgroundColor: colors.border.main,
		transform: 'translateY(-50%)',
		':after': {
			content: '""',
			position: 'absolute',
			top: '50%',
			right: -2,
			width: spacing.xs,
			height: spacing.xs,
			backgroundColor: colors.border.main,
			borderRadius: '50%',
			transform: 'translateY(-50%)',
		},
	},
	preProcessContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	preProcessHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	preProcessTitle: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		color: colors.text.main,
	},
	preProcessStatus: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.main,
		margin: 0,
	},
	preProcessIndicator: {
		width: spacing.sm,
		height: spacing.sm,
		borderRadius: '50%',
		backgroundColor: colors.text.light,
		transition: 'background-color 0.3s ease',
	},
	preProcessIndicatorActive: {
		backgroundColor: colors.primary.main,
		boxShadow: '0 0 0 3px rgba(33, 150, 243, 0.2)',
	},
});
